"use client";
import React from "react";
import useOnScreen from "@/src/hooks/useOnScreen";
import { getTranslateClass } from "@/src/constants/animations";
import { AnimatedHeaderProps } from "./types";

const AnimatedVideoHeader: React.FC<AnimatedHeaderProps> = ({
  videoHeader,
  videoSubheader,
  contactButton,
  linkButton,
  openContactModal,
}) => {
  const { ref, isIntersecting } = useOnScreen<HTMLDivElement>(0.1, true);

  return (
    <div
      ref={ref}
      className={`video-header flex flex-col items-center text-center transition-all duration-700 ease-out 
        ${
          isIntersecting
            ? "translate-y-0 opacity-100 scale-100 blur-0"
            : `${getTranslateClass("top")} opacity-0 scale-95 blur-sm`
        }
      `}
    >
      <div className="bg-gray-900 bg-opacity-80 rounded-lg py-3 px-4">
        <h1 className="leading-none">{videoHeader}</h1>

        {videoSubheader && (
          <h6 className="mt-2 text-xl sm:text-xl lg:text-4xl">
            {videoSubheader}
          </h6>
        )}
      </div>

      {contactButton && (
        <button
          onClick={openContactModal}
          className="video-button mt-6 px-6 py-3 bg-white text-black rounded-lg shadow-md hover:opacity-[70%] transition text-xl sm:text-xl lg:text-4xl"
        >
          {contactButton.contact_button || "Contact Us"}
        </button>
      )}

      {linkButton && (
        <a
          href={linkButton.link_button.url}
          target={linkButton.link_button.target || "_self"}
          className="video-button mt-6 px-6 py-3 bg-white text-black rounded-lg shadow-md hover:opacity-[70%] transition text-xl sm:text-xl lg:text-4xl"
        >
          {linkButton.link_button.title || "Click Here"}
        </a>
      )}
    </div>
  );
};

export default AnimatedVideoHeader;
